
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wedstrijden/[slug]",
      function () {
        return require("private-next-pages/wedstrijden/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wedstrijden/[slug]"])
      });
    }
  